import { AsyncAction } from '../../base-classes';
import { FeedbackProvider } from '../providers/feedbackProvider';

export const SEND_FEEDBACK = new AsyncAction('SEND_FEEDBACK');

export function sendFeedback(baseUrl, authId, secret, feedback, stdParameters, verbose) {
  return {
    type: SEND_FEEDBACK.base,
    payload: postFeedback(baseUrl, authId, secret, feedback, stdParameters, verbose),
  };
}

async function postFeedback(baseUrl, authId, secret, feedback, stdParameters, verbose) {
  const op = new FeedbackProvider(baseUrl, authId, secret);
  return op.sendFeedback(feedback, stdParameters, verbose);
}
